import { ca } from '@cian/analytics';
import { getDeviceType } from '../../../../utils/detectDeviceType';

/**
 * Требования для аналитики:
 * https://conf.cian.tech/pages/viewpage.action?pageId=1255738378
 */
export function trackClickCollection(queryString: string, userAgent: string = '') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_collections',
    label: queryString,
    page: {
      siteType: getDeviceType(userAgent),
      pageType: 'Listing',
      extra: {
        queryString,
      },
    },
  });
}
